import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/logo.png';
const _hoisted_1 = {
  class: "sticky",
  style: {
    "top": "0",
    "z-index": "999"
  }
};
const _hoisted_2 = {
  class: "lg:px-6 bg-gray-900 mx-0 flex flex-row h-[3.5rem] md:h-16 2xl:h-16 font-mono"
};
const _hoisted_3 = {
  class: "h-full p-2 pl-4 md:pl-6 2xl:pl-8 flex items-center"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-4/5 mr-3 hidden lg:block",
  src: _imports_0
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-white text-xl md:text-2xl hidden lg:block"
}, "Minthe", -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-1 block lg:hidden"
}, null, -1);
const _hoisted_7 = {
  class: "flex-1 pl-6 pt-4 space-x-2 hidden lg:flex"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 0,
  class: "absolute flex flex-col top-[3.5rem] bg-gray-900 pt-2 pr-2 pb-2 left-0"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "flex items-center text-white space-x-12 text-base md:text-lg pr-2 font-bold"
};
const _hoisted_12 = {
  class: "rounded-lg pl-3 pr-3 pt-[0.3rem] pb-[0.3rem] text-white flex items-center",
  style: {
    "--bg-board-color": "rgb(30,41,59,.85)",
    "--bg-board-color-2": "rgb(2,6,23,.9)",
    "background-image": "linear-gradient(162deg,var(--bg-board-color) 28.7%,var(--bg-board-color-2,var(--bg-board-color)))"
  }
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 1,
  class: "ml-2 mr-2 i-mdi-dev-to scale-150"
};
const _hoisted_15 = {
  key: 2
};
const _hoisted_16 = {
  key: 0,
  class: "fixed left-0 top-0 font-mono z-10"
};
const _hoisted_17 = {
  class: "bg-[#5b5b5b70] w-[100vw] h-[100vh] sticky pt-0 flex justify-center"
};
const _hoisted_18 = {
  style: {
    "box-shadow": "0 8px 20px rgba(0,0,0,.6)"
  },
  class: "bg-slate-950 rounded-2xl w-[22rem] h-[30rem] md:h-[30rem] top-[10vh] relative shadow-md flex flex-col items-center overflow-y-auto"
};
const _hoisted_19 = {
  class: "w-5/6 text-center pt-4 flex item-center flex-col"
};
const _hoisted_20 = {
  class: "h-[3rem] w-full pt-3"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "i-mdi-close"
}, null, -1);
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-white text-2xl mt-3 mb-6"
}, [/*#__PURE__*/_createTextVNode("Connect a wallet on "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("Solana to continue")], -1);
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "items-center justify-between flex"
};
const _hoisted_26 = {
  class: "flex items-center"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "flex flex-col"
};
const _hoisted_29 = {
  class: "flex items-center"
};
const _hoisted_30 = {
  class: "text-lg"
};
const _hoisted_31 = {
  key: 0,
  class: "ml-3 i-mdi-dev-to scale-150"
};
const _hoisted_32 = {
  class: "text-[0.75rem] text-gray-500"
};
const _hoisted_33 = {
  key: 0,
  class: "text-slate-700 text-[0.8rem]"
};
const _hoisted_34 = {
  key: 1,
  class: "text-green-600 text-[0.8rem]"
};
const _hoisted_35 = {
  key: 0,
  class: "mt-2 flex flex-col text-[0.8rem]"
};
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "Public Key:")], -1);
const _hoisted_37 = {
  class: "text-slate-200"
};
const _hoisted_38 = {
  class: "flex space-x-3"
};
const _hoisted_39 = ["onClick"];
import { useRouter } from 'vue-router';
import { useStore } from '@/store';
import { ref } from 'vue';
import { switchWalletNetwork } from '@/wallets';
import { routes } from '@/router';
export default /*#__PURE__*/_defineComponent({
  __name: 'Tabbar',
  setup(__props) {
    const store = useStore();
    const show_drawer = ref(false);
    const router = useRouter();
    return (_ctx, _cache) => {
      var _unref$activate_walle, _unref$activate_walle2;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = $event => show_drawer.value = !show_drawer.value),
        class: "i-mdi-menu text-white scale-150 mr-2 cursor-pointer lg:hidden"
      }), _hoisted_4, _hoisted_5]), _hoisted_6, _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), route => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["cursor-pointer px-4 flex rounded-t-[0.5rem] h-full items-center text-white text-lg font-bold transition-all", route.path === _unref(router).currentRoute.value.path ? 'bg-slate-950' : 'bg-slate-800 hover:bg-slate-950 hover:mt-1']),
          onClick: $event => _unref(router).push(route.path)
        }, _toDisplayString((route.path === _unref(router).currentRoute.value.path ? '▶ ' : '') + route.meta.showtitle), 11, _hoisted_8);
      }), 256))]), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [show_drawer.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), route => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["cursor-pointer px-4 flex rounded-r-[0.5rem] h-full items-center text-white font-bold transition-all py-3 mt-1 mb-1", route.path === _unref(router).currentRoute.value.path ? 'bg-slate-950 text-xl' : 'text-lg bg-slate-800 hover:bg-slate-950 hover:mt-1']),
            onClick: $event => {
              show_drawer.value = false;
              _unref(router).push(route.path);
            }
          }, _toDisplayString((route.path === _unref(router).currentRoute.value.path ? '▶ ' : '') + route.meta.showtitle), 11, _hoisted_10);
        }), 256))])) : _createCommentVNode("", true)]),
        _: 1
      }), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => _unref(store).show_wallet_model = true),
        class: "bg-slate-800 pl-[0.15rem] pr-[0.15rem] pt-[0.1rem] pb-[0.1rem] mr-0 cursor-pointer rounded-lg",
        style: {
          "background-image": "linear-gradient(var(--gradient-rotate, 246deg), #f08080 7.97%, rgb(219 39 119) 92.1%)"
        }
      }, [_createElementVNode("div", _hoisted_12, [_unref(store).activate_wallet != undefined ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "w-[1.5rem] h-[1.5rem] mr-4 ml-1",
        src: _unref(store).activate_wallet.adapter.icon
      }, null, 8, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_unref(store).activate_wallet == undefined ? 'Connect Wallet' : `${_unref(store).activate_wallet.name}`), 1), _unref(store).activate_wallet != undefined && _unref(store).activate_wallet.network == 'devnet' ? (_openBlock(), _createElementBlock("span", _hoisted_14)) : _createCommentVNode("", true), _unref(store).activate_wallet != undefined ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(`:
              ${(_unref$activate_walle = _unref(store).activate_wallet.adapter.publicKey) === null || _unref$activate_walle === void 0 ? void 0 : _unref$activate_walle.toBase58().substring(0, 4)}....${(_unref$activate_walle2 = _unref(store).activate_wallet.adapter.publicKey) === null || _unref$activate_walle2 === void 0 ? void 0 : _unref$activate_walle2.toBase58().slice(-4)}`), 1)) : _createCommentVNode("", true)])])])])]), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [_unref(store).show_wallet_model ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = $event => _unref(store).show_wallet_model = false),
          class: "absolute right-[2rem] h-[1.5rem] w-[1.5rem] bg-[#1c2338] rounded-[50%] scale-[1.5] flex justify-center items-center text-slate-400 hover:text-slate-200 cursor-pointer transition-colors"
        }, _hoisted_22)]), _hoisted_23]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).wallets, wallet => {
          var _wallet$adapter$publi;
          return _openBlock(), _createElementBlock("div", {
            onClick: $event => _unref(store).clickSwitchWallet(wallet),
            class: _normalizeClass(["w-full text-white text-left hover:bg-slate-800 pl-4 pt-4 pb-4 pr-4 flex flex-col cursor-pointer font-bold", wallet == _unref(store).activate_wallet ? 'border-[0.1rem] border-dashed border-indigo-700 bg-indigo-950 ' : ''])
          }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
            class: "w-[2rem] h-[2rem] mr-4 ml-1",
            src: wallet.adapter.icon
          }, null, 8, _hoisted_27), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(wallet.name), 1), wallet.network == 'devnet' ? (_openBlock(), _createElementBlock("span", _hoisted_31)) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_32, _toDisplayString(wallet.network), 1)])]), _createElementVNode("div", null, [!wallet.adapter.connected ? (_openBlock(), _createElementBlock("div", _hoisted_33, "NoConnect")) : _createCommentVNode("", true), wallet.adapter.connected ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Connected!")) : _createCommentVNode("", true)])]), wallet == _unref(store).activate_wallet ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_hoisted_36, _createElementVNode("span", _hoisted_37, _toDisplayString(`${(_wallet$adapter$publi = wallet.adapter.publicKey) === null || _wallet$adapter$publi === void 0 ? void 0 : _wallet$adapter$publi.toBase58()}`), 1), _createElementVNode("div", _hoisted_38, [_createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = e => {
              e.stopPropagation();
              _unref(store).clickdisconnectWallet(_unref(store).activate_wallet);
            }),
            class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-2 px-4 rounded items-center mt-3 transition-colors"
          }, " Disconnect "), _createElementVNode("button", {
            onClick: async e => {
              e.stopPropagation();
              _unref(store).activate_wallet = undefined;
              await _unref(switchWalletNetwork)(wallet);
              _unref(store).activate_wallet = wallet;
            },
            class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-2 px-4 rounded items-center mt-3 transition-colors"
          }, " Switch to " + _toDisplayString(wallet.network === "devnet" ? "main-net" : "dev-net"), 9, _hoisted_39)])])) : _createCommentVNode("", true)], 10, _hoisted_24);
        }), 256))])])])) : _createCommentVNode("", true)]),
        _: 1
      })], 64);
    };
  }
});